module.exports = __webpack_public_path__ + "img/Impact interaction-Impact characterisation.a83d0e05.svg";